import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Account from "./pages/Account/Account";
import Inventory from "./pages/Inventory";
import Order from "./pages/Order/Order";
import Tickets from "./pages/Tickets/Tickets";
import Transfer from "./pages/Transfer";
import Setting from "./pages/Settings";
import AccountDetail from "./pages/Account/AccountDetail";
import Login from "./pages/Auth/Login";
import Login2 from "./pages/Auth/Login2";
import AddAccount from "./pages/Account/AddAccount";
import { SnackbarProviderWrapper } from "./components/Misc/useSnackbar";
import { Provider } from "react-redux";
import store from "./redux/store";
import Signup from "./pages/Auth/Signup";

export default function App() {
  return (
    <Provider store={store}>
      <SnackbarProviderWrapper>
        <BrowserRouter>
          <Routes>
            <Route path="/account/list" element={<Account />} />
            <Route path="/account/add" element={<AddAccount />} />
            <Route path="/account/detail" element={<AccountDetail />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/order" element={<Order />} />
            <Route path="/tickets" element={<Tickets />} />
            <Route path="/transfer" element={<Transfer />} />
            <Route path="/settings" element={<Setting />} />
            <Route path="/login" element={<Login />} />
            <Route path="/login2" element={<Login2 />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/" element={<Navigate to="/account/list" />} />

            {/* Fallback route for undefined paths */}
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </BrowserRouter>
      </SnackbarProviderWrapper>
    </Provider>
  );
}
